import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {mineShaft} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  date: {
    color: mineShaft,
  },
  version: {
    color: mineShaft,
  },
  container: {
    paddingTop: indent * 0.8,
  },
});
